<template>
    <div class="disclaimer-card">
      <p>
        Your ad will be rejected if it does not comply with our
        <a href="/posting-guidelines" target="_blank" class="link">posting guidelines</a>.
        Got questions? <a href="mailto:support@example.com" class="link">Email us</a>.
      </p>
      <p>
        By proceeding, I confirm that I have reviewed the information provided above and confirm that such information is complete and accurate.
        <a href="/terms-and-conditions" target="_blank" class="link">Terms & Conditions</a>.
      </p>
    </div>
  </template>
  
  <style scoped>
  .disclaimer-card {
    background-color: #f9f9f9;
    padding: 16px;
    border: 1px solid #ddd;
    border-radius: 8px;
    margin-top: 16px;
    font-size: 0.875rem;
    color: #555;
  }
  
  .link {
    color: #007bff;
    text-decoration: none;
  }
  
  .link:hover {
    text-decoration: underline;
  }
  </style>